import {FormField, FormFieldType, SelectionOption} from 'lionheartland';
import {ENWeeklyReportSection} from '../../enums';

export class PostPlanWorkAssociationFormFields {

    public name: FormField
    public reportSection: FormField
    public plan: FormField
    public work: FormField

    constructor() {

        this.name = new FormField(
          'name',
          'Name',
          null,
          FormFieldType.text,
          true,
        )
        this.reportSection = new FormField(
          'reportSection',
          'Report section',
          null,
          FormFieldType.enumeration,
          true,
        )
        this.reportSection.enumeration = ENWeeklyReportSection
        this.plan = new FormField(
          'plan',
          'Plan',
          'plan',
          FormFieldType.pushedSelectionList,
          true,
        )
        this.work = new FormField(
          'work',
          'Work',
          'work',
          FormFieldType.pushedSelectionList,
          true,
        )

    }
}

const fields = new PostPlanWorkAssociationFormFields()

export const postPlanWorkAssociationFormFieldOptions: {[key: string]: FormField} = {
  name: fields.name,
  reportSection: fields.reportSection,
  plan: fields.plan,
  work: fields.work,
};